/// <amd-module name="VSS/Features/Directory/components/DirectoryContentView/index" />
export * from "./DirectoryContentView";
